import { createAction } from '@reduxjs/toolkit'

// Special action handled by root reducer
export const userLogout = createAction('LOGOUT_USER')
